import { createFileRoute } from '@tanstack/react-router'
import ImportTransactions from 'Imports/components/Transactions/ImportTransactions'

import { Guard } from '../-guard'

export const Route = createFileRoute('/imports/importtransaction')({
    component: () => (
        <Guard claims={['opus_royalty']}>
            <ImportTransactions />
        </Guard>
    ),
})
